<script lang="ts">
	import { URLPART_TYPE_LISTING } from '$lib/consts'
	import { t } from '$lib/translations.js'
	import { MARKETPLACE } from '$params/marketplace'

	export let data
	const showAll: boolean[] = []
	const formType = 'hvac'
</script>

{#if data.regions}
	<div class="page-wrapper pb-24">
		<h1>{t('web.region_list.heading')}:</h1>
		<div class="flex flex-col">
			{#each data.regions as region, i}
				<div class="relative">
					<h2
						class="sticky bottom-16 top-16 !mt-0 w-full border-b border-neutral-200 bg-white pb-2 pt-8"
					>
						{region.attributes.name}
					</h2>
					<div class="flex flex-wrap gap-x-2 gap-y-3" class:hidden={showAll[i]}>
						{#each region.attributes.cities.data.slice(0, 20) as city}
							<a
								href="/{MARKETPLACE}/{URLPART_TYPE_LISTING[formType]}/{city.attributes.slug}"
								class="rounded-full bg-neutral-200/80 px-3 py-1 hover:bg-neutral-300/80"
								>{t('web.region_list.heatPumpsIn', { region: city.attributes.name })}</a
							>
						{/each}
						<button
							on:click={() => (showAll[i] = true)}
							class="rounded-full border bg-neutral-200/80 px-3 py-1 underline hover:bg-neutral-300/80"
							>{t('web.region_list.showAll')}</button
						>
					</div>
					<div class="flex flex-wrap gap-x-2 gap-y-3" class:hidden={!showAll[i]}>
						{#each region.attributes.cities.data as city}
							<a
								href="/{MARKETPLACE}/{URLPART_TYPE_LISTING[formType]}/{city.attributes.slug}"
								class="rounded-full bg-neutral-200/80 px-3 py-1 hover:bg-neutral-300/80"
								>{t('web.region_list.heatPumpsIn', { region: city.attributes.name })}</a
							>
						{/each}
						<button
							on:click={() => (showAll[i] = false)}
							class="rounded-full border bg-neutral-200/80 px-3 py-1 underline hover:bg-neutral-300/80"
							>{t('web.region_list.showLess')}</button
						>
					</div>
				</div>
			{/each}
		</div>
	</div>
{/if}
